import { Component, ViewChild, OnInit, Input } from '@angular/core';
import { CrawfordSnackbarService, CrawfordSpinnerService, ITabComponent,
  CrawfordGridComponent, GridColumn, DateFormat } from 'crawford-shell';

import { global } from '../../app.settings';

import { ClaimDate } from '../model/claim-date.model';
import { ClaimService } from '../claim.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-claim-dates',
  templateUrl: './claim-dates.component.html',
  styleUrls: ['./claim-dates.component.scss']
})
export class ClaimDatesComponent implements OnInit, ITabComponent {

  @Input() public crawfordRef: string;
  @Input() public source: string;
  @ViewChild('ccogrid') public ccoGrid: CrawfordGridComponent;

  dataLoaded = false;
  public gridData: ClaimDate[];

  df: DateFormat = {
    type: 'date',
    format: global.dateFormat};

  displayColumns: GridColumn[] = [
    new GridColumn('description', 'Description'),
    new GridColumn('date', 'Date')
  ];

  constructor(private claimService: ClaimService,
              public snackBar: CrawfordSnackbarService,
              private spinnerService: CrawfordSpinnerService,
            private activatedRoute: ActivatedRoute) { }

  ngOnInit() { }

  loadData(): void {
    if (!this.dataLoaded) {
      this.spinnerService.show('claimDatesSpinner');
      this.createGridData();
    }
  }

  createGridData() {
    this.claimService.getClaimDates(this.crawfordRef, this.source).subscribe(claimDateResult => {
      if (claimDateResult) {
        this.gridData = [
          {description: 'Date & time of Instruction', date: claimDateResult.instructionDate},
          {description: 'Date & time of Attempted First Contact', date: claimDateResult.attemptedContactDate},
          {description: 'Date & time of Actual Contact', date: claimDateResult.firstContactDate},
          {description: 'Date & time of Scheduled Visit', date: claimDateResult.plannedVisitDate},
          {description: 'Date & time of Actual Visit', date: claimDateResult.firstVisitDate},
          {description: 'Date of First Report', date: claimDateResult.preliminaryReportDate},
          {description: 'Date of Last Interim Report', date: claimDateResult.lastInterimDate},
          {description: 'Date of Final Report', date: claimDateResult.finalReportDate},
          {description: 'Date of File Closure', date: claimDateResult.closureDate}
        ];
          this.dataLoaded = true;
        } else {
          this.snackBar.displayErrorMessage('No Dates found for that Claim Reference');
        }
        this.spinnerService.hide('claimDatesSpinner');
      },
      error => {
        this.spinnerService.hide('claimDatesSpinner');
      }
    );
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-dates/claim-dates.component.ts